import { AppSettings } from '../app.settings';

export class AutoRefreshTimerService {
	private static _interval: any;
	private static _elapsedSeconds: number = 0;
	private static _stepInSeconds: number = 5;
	private static _isLocked: boolean;
	private static _thresholdSeconds: number;

	public static start(): void {
		if (!!this._interval) {
			this.stop();
		}

		this.initInterval();
	}

	public static stop(): void {
		if (!this._interval) return;
		clearInterval(this._interval);
		this._interval = null;
	}

	public static lock(): void {
		this._isLocked = true;
	}

	public static unlock(): void {
		this._isLocked = false;
	}

	private static initInterval(): void {
		if (AppSettings.autoRefreshRedirectUri === '[arUri]') return;
		this._elapsedSeconds = 0;
		this._thresholdSeconds = AppSettings.autoRefreshMinutes * 60;

		this._interval = setInterval(() => {
			this._elapsedSeconds += this._stepInSeconds;
			if (!this._isLocked && this._elapsedSeconds >= this._thresholdSeconds) {
				window.location.href = AppSettings.autoRefreshRedirectUri;
			}
		}, this._stepInSeconds * 1000);
	}
}
